import React from 'react'
import Navbar from '../components/Navbar'
import Faq from '../components/Faq'
import Footer from '../components/Footer'


const FaqPage = () => {
  return (
    <>
    <Navbar/>
    <Faq/>
    <Footer/>
      
    </>
  )
}

export default FaqPage
